// Generated by AI on 06/09/2026
import { QueryClient, MutationCache } from '@tanstack/react-query';
import Logger from './services/logger';
import { FIVE_MINUTES_MS, TEN_MINUTES_MS } from './constants/queryKeys';

const queryClient = new QueryClient({
    mutationCache: new MutationCache({
        onError: (error) => {
            Logger.error(error);
        },
    }),
    defaultOptions: {
        queries: {
            staleTime: FIVE_MINUTES_MS,
            gcTime: TEN_MINUTES_MS,
            retry: 1,
            refetchOnWindowFocus: false,
            refetchOnReconnect: true,
        },
        mutations: {
            retry: 0,
        },
    },
});

export default queryClient;
